export const state = {
  product: null,
  products: []
}

export default state



// WEBPACK FOOTER //
// ./src/store/module/product/state.js